/**
 * ダム模式図生成
 */
import color from "../scss/color.scss";

export default {
  name: "lib-dam-diag",
  getSvgDamDiag,
  getImageDamDiag,
};

// 描画単位
const viewUnit = "px";
// 描画領域幅
const viewWidth = 1800;
// 描画領域高
const viewHeight = 900;
// 描画パディング
const viewPadding = 16;
// 枠丸み
const frameRadius = 16;
// ダム描画位置
const damRatio = 0.7;
// ダム天端位置
const damTopRatio = 0.7;
// ダム天端幅
const damTopWidth = 40;
// ダム底幅
const damBottomWidth = 80;
// ダム斜面上位置
const damSlopeTopRatio = 0.8;
// ダム斜面位置
const damSlopeRatio = 0.55;
// ダム底
const damBottom = 79;
// ダム水位表示位置
const damStageRatio = 0.2;
// ダム最高水位（天端 - 最高水位）
const damStageMax = 80;
// ダム最低水位（ダム底 = 最低水位）
const damStageMin = 80;
// 下流水位
const downStage = 40;
// 水位表示桁数（小数第３位以下切り捨て）
const fixedStage = 2;
// 流量表示桁数（小数第３位以下切り捨て）
const fixedFlow = 2;
// 貯水率表示桁数（小数第２位以下切り捨て）
const fixedStor = 1;
// 雨量表示桁数（小数第２位以下切り捨て）
const fixedRain = 1;

// 文字列（上昇）
const strUp = "↑";
// 文字列（加工）
const strDown = "↓";
// 文字列（区切り文字）
const strDiv = "：";
// 文字列（水位単位）
const strUnit = "m";
// 文字列（率単位）
const strPcnt = "%";
// 文字列（雨量単位）
const strRainUnit = "mm";
// 文字列（流量単位）
const strFlowUnit = "㎥/s";
// 文字列（期間）
const strPeriod = "～";
// 文字列（欠測）
const strLess = "欠測";
// 文字列（閉局）
const strClose = "閉局";
// 文字列（その他）
const strOther = "--";
// 文字列（洪水時最高水位）
const strDamSrchg = "洪水時最高水位";
// 文字列（平常時最高貯水位）
const strDamNormal = "平常時最高貯水位";
// 文字列（貯水位）
const strDamStage = "現在の貯水位";
// 文字列（最低水位）
const strDamMin = "最低水位";
// 文字列（貯水率(利水容量)）
const strIrr = "貯水率(利水容量)";
// 文字列（貯水率(治水容量)）
const strFlood = "貯水率(治水容量)";
// 文字列（洪水貯留準備水位）
const strStageStandby = "洪水貯留準備水位";
// 文字列（予備放流水位）
const strStageReserve = "予備放流水位";
// 文字列（異常洪水時防災操作開始水位）
const strStagePrvs = "緊急放流(異常洪水時防災操作)判断水位";
// 文字列（適用期間）
const strAppPeriod = "適用期間";
// 文字列（全流入量）
const strSink = "全流入量";
// 文字列（全放流量）
const strDisch = "全放流量";
// 文字列（注釈）
const strDamComment = "※この図は模式図であり、実際のダムの形状とは異なります";
// 文字列（10分雨量）
const strRainMin10 = "10分雨量";
// 文字列（時間雨量）
const strRainHour = "時間雨量";
// 文字列（累加雨量）
const strRainTotal = "降り始めからの雨量";
// 文字列（ダム放流通知 平常）
const strDamDschNone = "発表中のダム放流通知はありません";
// 観測所情報の基準位置（x座標）
const obsInfoPosX = 40;
// 観測所情報の高さ（y）
const obsInfoHeight = 80;

// ダム模式図のスタイル
const styleCss = `<![CDATA[
.kwd-frame {
  fill: ghostwhite;
  stroke: black;
  stroke-width: 1;
}
.kwd-stage {
  fill: lightskyblue;
  stroke: lightskyblue;
  stroke-width: 1;
  opacity: 0.8;
}
.kwd-stage-line {
  stroke: royalblue;
  stroke-width: 3;
  opacity: 1.0;
}
.kwd-stage-line-prvs {
  stroke: ${color.rwDamdschPrevop};
  stroke-width: 3;
  opacity: 1.0;
}
.kwd-stage-dashline {
  stroke: ${color.popupFrame};
  stroke-width: 5;
  stroke-dasharray: 4 9;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 1.0;
}
.kwd-stage-up {
  fill: ${color.arrowUp};
  font-weight: 800;
  font-size: 36px;
}
.kwd-stage-down {
  fill: ${color.arrowDown};
  font-weight: 800;
  font-size: 36px;
}
.kwd-dam {
  fill: lightgray;
  stroke: darkgray;
  stroke-width: 1;
  opacity: 1.0;
}
.kwd-dam-arrow {
  fill: dodgerblue;
  stroke: royalblue;
  stroke-width: 2;
  opacity: 0.95;
}
.kwd-dam-bottom {
  fill: navajowhite;
  stroke: navajowhite;
  stroke-width: 1;
  opacity: 1.0;
}
.kwd-dam-slope {
  fill: sandybrown;
  stroke: sandybrown;
  stroke-width: 1;
  opacity: 1.0;
}
.kwd-dam-bold {
  fill: black;
  font-weight: 600;
  font-size: 40px;
}
.kwd-dam-text {
  fill: black;
  font-weight: 500;
  font-size: 36px;
}
.kwd-dam-text-prvs {
  fill: black;
  font-weight: 500;
  font-size: 29px;
}
.kwd-dam-comment {
  fill: black;
  font-weight: 400;
  font-size: 32px;
  opacity: 0.9;
}
.kwd-info-frame {
  fill: white;
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-frame-prvs {
  fill: white;
  stroke: ${color.rwDamdschPrevop};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-frame-caution {
  fill: ${color.rainTotalCaution};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-caution {
  fill: ${color.rainTotalCautionText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-info-frame-warning {
  fill: ${color.rainTotalWarning};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-warning {
  fill: ${color.rainTotalWarningText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-info-frame-stage-over {
  fill: ${color.tmStgFlood};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-stage-over {
  fill: ${color.tmStgFloodText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-info-frame-stage-danger {
  fill: ${color.tmStgDanger};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-stage-danger {
  fill: ${color.tmStgDangerText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-info-frame-stage-refuge {
  fill: ${color.tmStgRefuge};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-stage-refuge {
  fill: ${color.tmStgRefugeText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-info-frame-stage-warning {
  fill: ${color.tmStgWarn};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-stage-warning {
  fill: ${color.tmStgWarnText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-info-frame-stage-standby {
  fill: ${color.tmStgFldctl};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-info-text-stage-standby {
  fill: ${color.tmStgFldctlText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-dam-dsch-tm-prevop-frame {
  fill: ${color.tmDamdschPrevop};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-dam-dsch-tm-prevop-text {
  fill: ${color.tmDamdschPrevopText};
  font-weight: 600;
  font-size: 36px;
}
.kwd-dam-dsch-tm-storop-frame {
  fill: ${color.tmDamdschStorop};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-dam-dsch-tm-storop-text {
  fill: ${color.tmDamdschStoropText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-dam-dsch-tm-none-frame {
  fill: ${color.tmDamdschNormal};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-dam-dsch-tm-none-text {
  fill: ${color.tmDamdschNormalText};
  font-weight: 400;
  font-size: 36px;
}
.kwd-dam-dsch-rw-prevop-frame {
  fill: ${color.rwDamdschPrevop};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-dam-dsch-rw-prevop-text {
  fill: ${color.rwDamdschPrevopText};
  font-weight: 600;
  font-size: 36px;
}
.kwd-dam-dsch-rw-storop-frame {
  fill: ${color.rwDamdschStorop};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-dam-dsch-rw-storop-text {
  fill: ${color.rwDamdschStoropText};
  font-weight: 500;
  font-size: 36px;
}
.kwd-dam-dsch-rw-none-frame {
  fill: ${color.rwDamdschNormal};
  stroke: ${color.popupFrame};
  stroke-width: 4;
  opacity: 1.0;
}
.kwd-dam-dsch-rw-none-text {
  fill: ${color.rwDamdschNormalText};
  font-weight: 400;
  font-size: 36px;
}
.kwd-dam-obsinfo-label {
  fill: black;
  font-weight: 400;
  font-size: 40px;
}
]]>`;

/**
 * SVGダム模式図取得
 * @param obsInfo 観測所情報
 *    value: 観測値
 *        date: 観測日
 *        time: 観測時間
 *        dam: ダム諸量(10分/時間雨量で切替)
 *            lvl: 貯水位
 *            lvlCcd: 貯水位内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            chg: 水位変化(up=増加, down=減少, non=変化なし)
 *            irr: 貯水率(利水容量)
 *            irrCcd: 貯水率(利水容量)内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            flood: 貯水率(治水容量)
 *            floodCcd: 貯水率(治水容量)コード(0=正常, 140=閉局, 190=欠測, その他)
 *            sink: 全流入量
 *            sinkCcd: 全流入量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            disch: 全放流量
 *            dischCcd: 全放流量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *        rain: 雨量
 *            rain: 10分/時間雨量
 *            rainCcd: 雨量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            cautOvflg: 10分/時間雨量 注意値超過フラグ
 *            warnOvflg: 10分/時間雨量 警戒値超過フラグ
 *            total: 累加雨量
 *            totalCcd: 累加雨量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            totalCautOvflg: 累加雨量 注意値超過フラグ
 *            totalWarnOvflg: 累加雨量 警戒値超過フラグ
 *        stage: 下流水位(10分/時間雨量で切替)
 *            lvl: 水位(堤防天端から)
 *            lvlCcd: 水位内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            stgOvlvl: 基準水位超過
 *    dsch: ダム放流通知
 *        lvl: レベル(0=平常, 1=洪水貯留操作実地中, 2=異常洪水時防災操作等実施中)
 *        name: ダム放流通知種別名
 *    spec: 観測所情報
 *        dam: ダム諸量観測所
 *            name: 観測所名称
 *            proviso: 異常洪水時防災操作開始水位
 *            srchgStage: 洪水時最高水位
 *            normalStage: 平常時最高水位
 *            minStage: 最低水位
 *            floodctl: 洪水貯留操作開始流量
 *            dsgnFldLv: 設計最高水位
 *            limitStage: 洪水貯留準備水位
 *                value: 制限水位
 *                start: 制限水位期間開始
 *                end: 制限水位期間終了
 *            spareStage: 予備放流水位
 *                value: 制限水位
 *                start: 制限水位期間開始
 *                end: 制限水位期間終了
 *        rain: 関連雨量観測所
 *            name: 観測所名称
 *        stage: 下流水位観測雨所
 *            name: 観測所名称
 *            distance: ダムからの距離(km)
 *            label: 水位表記文字列
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    isFldCtl: 水防団モード（true=水防団, false=一般）
 * @return SVGグラフ
 */
function getSvgDamDiag(obsInfo, viewProp) {
  const valueDam = obsInfo.value.dam;
  const valueRain = obsInfo.value.rain;
  const specDam = obsInfo.spec.dam;
  const specRain = obsInfo.spec.rain;

  // SVGタグ生成
  let svg = makeSvg(viewProp, null);
  let g = svg.childNodes[1];
  // ダム描画
  addDam(g, specDam, valueDam, 0);
  // 流入量描画
  addDamSink(g, specDam, valueDam, 0);
  // 放流量描画
  addDamDisch(g, valueDam, 0);
  // 上位観測所描画
  addRainInfo(g, specRain, valueRain, viewProp.isHour, 0);
  // ダム放流通知表示
  addDamDsch(g, obsInfo.dsch, 0);

  return svg.outerHTML;
}

/**
 * SVGタグ生成
 * @param {*} viewProp 描画プロパティ
 * @param {*} specObs 観測所情報
 * @return svgタグオブジェクト
 */
function makeSvg(viewProp, specObs) {
  // svgタグ要素生成
  let attrViewBox = "0 0 " + viewWidth + " " + viewHeight;
  if (specObs != null && viewProp.isInfo) {
    // 観測所情報表示の場合は高さを変える
    let viewHeightInfo = viewHeight + obsInfoHeight;
    attrViewBox = "0 0 " + viewWidth + " " + viewHeightInfo;
  }
  let attrWidth = viewProp.width + viewUnit;
  let attrHeight = viewProp.height + viewUnit;
  // svgタグ生成
  let svg = document.createElement("svg");
  svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  svg.setAttribute("viewBox", attrViewBox);
  svg.setAttribute("width", attrWidth);
  svg.setAttribute("height", attrHeight);

  // styleタグ要素生成
  let child = document.createTextNode(styleCss);
  // defs/styleタグ生成
  let defs = document.createElement("defs");
  let style = document.createElement("style");
  style.type = "text/css";
  style.appendChild(child);
  defs.appendChild(style);
  // 親要素に追加
  svg.appendChild(defs);

  // gタグ生成
  let g = document.createElement("g");
  g.setAttribute("id", "svg-dam-diag");
  // 親要素に追加
  svg.appendChild(g);

  return svg;
}

/**
 * ダム描画
 * @param {]} parent 親タグ要素
 * @param {*} spec ダム諸量観測所情報
 * @param {*} value ダム諸量観測値
 * @param {*} offsetY 余白の高さ
 */
function addDam(parent, spec, value, offsetY) {
  // ダムフレーム描画
  addFrame(parent, spec, value, offsetY);
  // ダム情報描画
  addDamInfo(parent, spec, offsetY);
  // 貯水率描画
  addDamStor(parent, spec, value, offsetY);
  // ダム描画
  addDamView(parent, spec, value, offsetY);
}

/**
 * ダムフレーム描画
 * @param {]} parent 親タグ要素
 * @param {*} spec ダム諸量観測所情報
 * @param {*} value ダム諸量観測値
 * @param {*} offsetY 余白の高さ
 */
function addFrame(parent, spec, value, offsetY) {
  const min = spec.minStage;
  // 基準となる上限水位を設定
  const baseStg = getBaseStage(
    spec.normalStage,
    spec.srchgStage,
    spec.dsgnFldLv
  );

  let tag, title, tip, x, y;
  // フレーム描画
  tag = document.createElement("rect");
  tag.setAttribute("x", 0);
  tag.setAttribute("y", offsetY);
  tag.setAttribute("width", viewWidth);
  tag.setAttribute("height", viewHeight + offsetY);
  tag.setAttribute("class", "kwd-frame");
  parent.appendChild(tag);

  // ダム底描画
  x = viewWidth * (1 - damRatio);
  y = viewHeight + offsetY - damBottom;
  tag = document.createElement("rect");
  tag.setAttribute("x", x);
  tag.setAttribute("y", y);
  tag.setAttribute("width", viewWidth - x - 1);
  tag.setAttribute("height", viewHeight + offsetY - y - 1);
  tag.setAttribute("class", "kwd-dam-bottom");
  parent.appendChild(tag);

  // ダム水位描画
  if (checkCcd(value.lvl, value.lvlCcd)) {
    const t = viewHeight * (1 - damTopRatio) + damStageMax + offsetY;
    const b = viewHeight + offsetY - damStageMin;
    // 水位描画限界の位置(比率)算出
    const dt = viewHeight * (1 - damTopRatio) + offsetY + 5;
    const maxPos = (b - dt) / (b - t);
    let h = (b - t) * computeDamStage(baseStg, min, value.lvl, maxPos);

    const cls = "kwd-stage";
    x = viewWidth * (1 - damRatio);
    y = b - h;
    tag = document.createElement("rect");
    tag.setAttribute("x", x);
    tag.setAttribute("y", y);
    tag.setAttribute("width", viewWidth - x - 1);
    tag.setAttribute("height", h);
    tag.setAttribute("class", cls);
    tip = makeToolTip(spec);
    title = document.createElement("title");
    title.appendChild(document.createTextNode(tip));
    tag.appendChild(title);
    parent.appendChild(tag);
  }

  // 下流水位描画
  tag = document.createElement("rect");
  y = viewHeight + offsetY - downStage;
  tag.setAttribute("x", 1);
  tag.setAttribute("y", y);
  tag.setAttribute("width", viewWidth * (1 - damRatio));
  tag.setAttribute("height", viewHeight + offsetY - y - 1);
  tag.setAttribute("class", "kwd-stage");
  parent.appendChild(tag);

  // ダム斜面描画
  let slope =
    xy(viewWidth - 1, viewHeight * (1 - damSlopeTopRatio) + offsetY) +
    xy(viewWidth * (1 - damSlopeRatio), viewHeight + offsetY - 1) +
    xy(viewWidth - 1, viewHeight + offsetY - 1);
  tag = document.createElement("polygon");
  tag.setAttribute("points", slope);
  tag.setAttribute("class", "kwd-dam-slope");
  tip = makeToolTip(spec);
  title = document.createElement("title");
  title.appendChild(document.createTextNode(tip));
  tag.appendChild(title);
  parent.appendChild(tag);

  // 注釈描画
  tag = document.createElement("text");
  tag.setAttribute("x", viewWidth - viewPadding);
  tag.setAttribute("y", viewHeight + offsetY - viewPadding);
  tag.setAttribute("text-anchor", "end");
  tag.setAttribute("class", "kwd-dam-comment");
  tag.appendChild(document.createTextNode(strDamComment));
  parent.appendChild(tag);
}

/**
 * ダム情報描画
 * @param {]} parent 親タグ要素
 * @param {*} spec ダム諸量観測所情報
 * @param {*} offsetY 余白の高さ
 */
function addDamInfo(parent, spec, offsetY) {
  const isSrchg = checkPeriod(spec.limitStage);
  const isSpare = checkPeriod(spec.spareStage);
  const srchg = spec.srchgStage;
  const min = spec.minStage;

  const t = viewHeight * (1 - damTopRatio) + damStageMax + offsetY;
  const b = viewHeight + offsetY - damStageMin;
  const l = viewWidth * (1 - damRatio) + damBottomWidth;
  // 水位描画限界の位置(比率)算出
  const dt = viewHeight * (1 - damTopRatio) + offsetY + 5;
  const maxPos = (b - dt) / (b - t);

  // 基準となる上限水位を設定
  const baseStg = getBaseStage(
    spec.normalStage,
    spec.srchgStage,
    spec.dsgnFldLv
  );

  let tag, text;
  // ダム洪水時最高水位描画
  let s = computeDamStage(baseStg, min, spec.srchgStage, maxPos);
  if (null != s) {
    s = b - (b - t) * s;
    tag = document.createElement("line");
    tag.setAttribute("x1", viewWidth * (1 - damRatio));
    tag.setAttribute("x2", viewWidth - 1);
    tag.setAttribute("y1", s);
    tag.setAttribute("y2", s);
    tag.setAttribute("class", "kwd-stage-line");
    parent.appendChild(tag);

    text = strDamSrchg + strDiv + fixedNumber(srchg, fixedStage) + strUnit;
    tag = document.createElement("text");
    tag.setAttribute("x", l);
    tag.setAttribute("y", s - 12);
    tag.setAttribute("text-anchor", "start");
    tag.setAttribute("class", "kwd-dam-text");
    tag.appendChild(document.createTextNode(text));
    parent.appendChild(tag);
  }

  // ダム平常時最高水位
  let n = computeDamStage(baseStg, min, spec.normalStage, maxPos);
  if (null != n && !isSrchg) {
    n = b - (b - t) * n;
    tag = document.createElement("line");
    tag.setAttribute("x1", viewWidth * (1 - damRatio));
    tag.setAttribute("x2", viewWidth - 1);
    tag.setAttribute("y1", n);
    tag.setAttribute("y2", n);
    tag.setAttribute("class", "kwd-stage-line");
    parent.appendChild(tag);

    tag = document.createElement("text");
    tag.setAttribute("x", viewWidth - 12);
    tag.setAttribute("y", n - 12);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", "kwd-dam-text");
    tag.appendChild(
      document.createTextNode(
        strDamNormal +
          strDiv +
          fixedNumber(spec.normalStage, fixedStage) +
          strUnit
      )
    );
    parent.appendChild(tag);
  }

  // 異常洪水時防災操作開始水位(ただし書き水位)
  // 常時表示
  const provStage = computeDamStage(baseStg, min, spec.proviso, maxPos);
  if (null != provStage) {
    // 水位表示
    let h = b - (b - t) * provStage;
    tag = document.createElement("line");
    tag.setAttribute("x1", viewWidth * (1 - damRatio));
    tag.setAttribute("x2", viewWidth - 1);
    tag.setAttribute("y1", h);
    tag.setAttribute("y2", h);
    tag.setAttribute("class", "kwd-stage-line-prvs");
    parent.appendChild(tag);

    // 説明
    const prvsw = 700;
    const prvsh = 64;
    const prvsx = (viewWidth - 260) / 2 - 380;
    const prvsy = viewHeight * (1 - damTopRatio) + offsetY - 90 + 40;
    tag = document.createElement("line");
    tag.setAttribute("x1", prvsx + prvsw - 18);
    tag.setAttribute("x2", prvsx + prvsw - 18);
    tag.setAttribute("y1", h);
    tag.setAttribute("y2", prvsy + prvsh / 2);
    tag.setAttribute("class", "kwd-stage-line-prvs");
    parent.appendChild(tag);
    // 枠
    tag = document.createElement("rect");
    tag.setAttribute("x", prvsx);
    tag.setAttribute("y", prvsy - prvsh / 2);
    tag.setAttribute("width", prvsw);
    tag.setAttribute("height", prvsh);
    tag.setAttribute("rx", frameRadius);
    tag.setAttribute("ry", frameRadius);
    tag.setAttribute("class", "kwd-info-frame-prvs");
    parent.appendChild(tag);

    // 水位情報
    text =
      strStagePrvs + strDiv + fixedNumber(spec.proviso, fixedStage) + strUnit;
    tag = document.createElement("text");
    tag.setAttribute("x", prvsx + 10);
    tag.setAttribute("y", prvsy + 10);
    tag.setAttribute("text-anchor", "start");
    tag.setAttribute("class", "kwd-dam-text-prvs");
    tag.appendChild(document.createTextNode(text));
    parent.appendChild(tag);
  }

  // 洪水貯留準備水位描画
  if (isSrchg) {
    const limit = spec.limitStage;
    const stage = computeDamStage(baseStg, min, limit.value, maxPos);
    if (null != stage) {
      let h = b - (b - t) * stage;
      tag = document.createElement("line");
      tag.setAttribute("x1", viewWidth * (1 - damRatio));
      tag.setAttribute("x2", viewWidth - 1);
      tag.setAttribute("y1", h);
      tag.setAttribute("y2", h);
      tag.setAttribute("class", "kwd-stage-line");
      parent.appendChild(tag);

      text =
        strStageStandby +
        strDiv +
        fixedNumber(limit.value, fixedStage) +
        strUnit;
      tag = document.createElement("text");
      tag.setAttribute("x", viewWidth - 12);
      tag.setAttribute("y", h - 52);
      tag.setAttribute("text-anchor", "end");
      tag.setAttribute("class", "kwd-dam-text");
      tag.appendChild(document.createTextNode(text));
      parent.appendChild(tag);

      tag = document.createElement("text");
      tag.setAttribute("x", viewWidth - 12);
      tag.setAttribute("y", h - 12);
      tag.setAttribute("text-anchor", "end");
      tag.setAttribute("class", "kwd-dam-comment");
      tag.appendChild(
        document.createTextNode(
          "(" +
            strAppPeriod +
            strDiv +
            spec.limitStage.start +
            strPeriod +
            spec.limitStage.end +
            ")"
        )
      );
      parent.appendChild(tag);
    }
  }

  // 予備放流水位描画
  if (isSpare) {
    const spare = spec.spareStage;
    const stage = computeDamStage(baseStg, min, spare.value, maxPos);
    if (null != stage) {
      let h = b - (b - t) * stage;
      tag = document.createElement("line");
      tag.setAttribute("x1", viewWidth * (1 - damRatio));
      tag.setAttribute("x2", viewWidth - 1);
      tag.setAttribute("y1", h);
      tag.setAttribute("y2", h);
      tag.setAttribute("class", "kwd-stage-line");
      parent.appendChild(tag);

      text =
        strStageReserve +
        strDiv +
        fixedNumber(spare.value, fixedStage) +
        strUnit;
      tag = document.createElement("text");
      tag.setAttribute("x", viewWidth - 12);
      tag.setAttribute("y", h + 36);
      tag.setAttribute("text-anchor", "end");
      tag.setAttribute("class", "kwd-dam-text");
      tag.appendChild(document.createTextNode(text));
      parent.appendChild(tag);

      text =
        "(" + strAppPeriod + strDiv + spare.start + strPeriod + spare.end + ")";
      tag = document.createElement("text");
      tag.setAttribute("x", viewWidth - 12);
      tag.setAttribute("y", h + 72);
      tag.setAttribute("text-anchor", "end");
      tag.setAttribute("class", "kwd-dam-comment");
      tag.appendChild(document.createTextNode(text));
      parent.appendChild(tag);
    }
  }

  // ダム最低水位描画
  if (null != min) {
    tag = document.createElement("text");
    tag.setAttribute("x", viewWidth - 12);
    tag.setAttribute("y", b - 12);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", "kwd-dam-text");
    tag.appendChild(
      document.createTextNode(
        strDamMin + strDiv + fixedNumber(min, fixedStage) + strUnit
      )
    );
    parent.appendChild(tag);
  }
}

/**
 * 貯水率描画
 * @param {]} parent 親タグ要素
 * @param {*} spec ダム諸量観測所情報
 * @param {*} value ダム諸量観測値
 * @param {*} offsetY 余白の高さ
 */
function addDamStor(parent, spec, value, offsetY) {
  const isSrchg = checkPeriod(spec.limitStage);
  const min = spec.minStage;
  // 基準となる上限水位を設定
  const baseStg = getBaseStage(
    spec.normalStage,
    spec.srchgStage,
    spec.dsgnFldLv
  );

  const t = viewHeight * (1 - damTopRatio) + damStageMax + offsetY;
  const b = viewHeight + offsetY - damStageMin;
  const l = viewWidth * (1 - damRatio) + damBottomWidth;
  // 水位描画限界の位置(比率)算出
  const dt = viewHeight * (1 - damTopRatio) + offsetY + 5;
  const maxPos = (b - dt) / (b - t);

  if (spec.normalStage != null || spec.srchgStage != null) {
    let n = computeDamStage(baseStg, min, spec.normalStage, maxPos);
    if (isSrchg) {
      n = computeDamStage(baseStg, min, spec.limitStage.value, maxPos);
    }
    n = b - (b - t) * n;

    let tag, text;
    // 貯水率(利水容量)描画
    if (
      null != n &&
      checkCcd(value.irr, value.irrCcd) &&
      checkCcd(value.lvl, value.lvlCcd)
    ) {
      let h = b - (b - t) * computeDamStage(baseStg, min, value.lvl, maxPos);
      if (h < n) {
        h = n;
      }
      let arrow =
        xy(l + 30, n) +
        xy(l, n + 30) +
        xy(l + 15, n + 30) +
        xy(l + 15, b - 30) +
        xy(l, b - 30) +
        xy(l + 30, b) +
        xy(l + 60, b - 30) +
        xy(l + 45, b - 30) +
        xy(l + 45, n + 30) +
        xy(l + 60, n + 30);
      tag = document.createElement("polygon");
      tag.setAttribute("points", arrow);
      tag.setAttribute("class", "kwd-dam-arrow");
      parent.appendChild(tag);

      text =
        strIrr +
        strDiv +
        toStringValueCheckCcd(value.irr, value.irrCcd, fixedStor, strPcnt);
      tag = document.createElement("text");
      tag.setAttribute("x", l + 60);
      tag.setAttribute("y", n + 10 + (b - n) / 2);
      tag.setAttribute("text-anchor", "start");
      tag.setAttribute("class", "kwd-dam-text");
      tag.appendChild(document.createTextNode(text));
      parent.appendChild(tag);
    }
    // 貯水率(治水容量)描画
    if (
      null != n &&
      checkCcd(value.flood, value.floodCcd) &&
      null != spec.srchgStage &&
      spec.srchgStage > min
    ) {
      if (isSrchg) {
        // 洪水時最高水位の位置を算出
        let srchgPos = computeDamStage(baseStg, min, spec.srchgStage, maxPos);
        srchgPos = b - (b - t) * srchgPos;

        let arrow =
          xy(l + 30, srchgPos) +
          xy(l, srchgPos + 30) +
          xy(l + 15, srchgPos + 30) +
          xy(l + 15, n - 30) +
          xy(l, n - 30) +
          xy(l + 30, n) +
          xy(l + 60, n - 30) +
          xy(l + 45, n - 30) +
          xy(l + 45, srchgPos + 30) +
          xy(l + 60, srchgPos + 30);
        tag = document.createElement("polygon");
        tag.setAttribute("points", arrow);
        tag.setAttribute("class", "kwd-dam-arrow");
        parent.appendChild(tag);

        text =
          strFlood +
          strDiv +
          toStringValueCheckCcd(
            value.flood,
            value.floodCcd,
            fixedStor,
            strPcnt
          );
        tag = document.createElement("text");
        tag.setAttribute("x", l + 60);
        tag.setAttribute("y", t + 10 + (n - t) / 2);
        tag.setAttribute("text-anchor", "start");
        tag.setAttribute("class", "kwd-dam-text");
        tag.appendChild(document.createTextNode(text));
        parent.appendChild(tag);
      }
    }
  }
}

/**
 * ダム描画
 * @param {]} parent 親タグ要素
 * @param {*} spec ダム諸量観測所情報
 * @param {*} value ダム諸量観測値
 * @param {*} offsetY 余白の高さ
 */
function addDamView(parent, spec, value, offsetY) {
  const min = spec.minStage;

  const t = viewHeight * (1 - damTopRatio) + offsetY + damStageMax;
  const b = viewHeight + offsetY - damStageMin;
  // 水位描画限界の位置(比率)算出
  const dt = viewHeight * (1 - damTopRatio) + offsetY + 5;
  const maxPos = (b - dt) / (b - t);

  // 基準となる上限水位を設定
  const baseStg = getBaseStage(
    spec.normalStage,
    spec.srchgStage,
    spec.dsgnFldLv
  );

  const stage = computeDamStage(baseStg, min, value.lvl, maxPos);

  let tag, text;
  // 現在の水位描画
  if (checkCcd(value.lvl, value.lvlCcd) && null != stage) {
    const l = (b - t) * stage;
    tag = document.createElement("line");
    tag.setAttribute("x1", viewWidth * (1 - damRatio));
    tag.setAttribute("x2", viewWidth - 1);
    tag.setAttribute("y1", b - l);
    tag.setAttribute("y2", b - l);
    tag.setAttribute("class", "kwd-stage-dashline");
    parent.appendChild(tag);
  }

  // ダム描画
  let dam =
    xy(
      viewWidth * (1 - damRatio) - damTopWidth,
      viewHeight * (1 - damTopRatio) + offsetY
    ) +
    xy(
      viewWidth * (1 - damRatio) + damTopWidth,
      viewHeight * (1 - damTopRatio) + offsetY
    ) +
    xy(viewWidth * (1 - damRatio) + damBottomWidth, viewHeight + offsetY - 1) +
    xy(viewWidth * (1 - damRatio) - damBottomWidth, viewHeight + offsetY - 1);
  tag = document.createElement("polygon");
  tag.setAttribute("points", dam);
  tag.setAttribute("class", "kwd-dam");
  parent.appendChild(tag);

  const x = 30;
  const y = viewHeight * damStageRatio + offsetY;
  const w = 320;
  const h = 120;

  // 現在の水位情報描画
  if (checkCcd(value.lvl, value.lvlCcd) && null != stage) {
    let l = (b - t) * stage;
    tag = document.createElement("line");
    tag.setAttribute("x1", x + w);
    tag.setAttribute("x2", viewWidth * (1 - damRatio) + damBottomWidth);
    tag.setAttribute("y1", y + h / 2);
    tag.setAttribute("y2", b - l);
    tag.setAttribute("class", "kwd-stage-dashline");
    parent.appendChild(tag);
  }
  // 枠
  tag = document.createElement("rect");
  tag.setAttribute("x", x);
  tag.setAttribute("y", y);
  tag.setAttribute("width", w);
  tag.setAttribute("height", h);
  tag.setAttribute("rx", frameRadius);
  tag.setAttribute("ry", frameRadius);
  tag.setAttribute("class", "kwd-info-frame");
  parent.appendChild(tag);
  // タイトル
  tag = document.createElement("text");
  tag.setAttribute("x", x + w / 2);
  tag.setAttribute("y", y + 52);
  tag.setAttribute("text-anchor", "middle");
  tag.setAttribute("class", "kwd-dam-bold");
  tag.appendChild(document.createTextNode(strDamStage));
  parent.appendChild(tag);
  // 現在の水位
  text = toStringValueCheckCcd(value.lvl, value.lvlCcd, fixedStage, strUnit);
  tag = document.createElement("text");
  tag.setAttribute("x", x + 150);
  tag.setAttribute("y", y + 100);
  tag.setAttribute("text-anchor", "middle");
  tag.setAttribute("class", "kwd-dam-bold");
  tag.appendChild(document.createTextNode(text));
  parent.appendChild(tag);
  // 増減マーカー
  if (
    checkCcd(value.lvl, value.lvlCcd) &&
    ("up" === value.chg || "down" === value.chg)
  ) {
    tag = document.createElement("text");
    tag.setAttribute("x", x + 240);
    tag.setAttribute("y", y + 100);
    tag.setAttribute("text-anchor", "start");
    tag.setAttribute("class", "kwd-stage-" + value.chg);
    tag.appendChild(
      document.createTextNode("up" === value.chg ? strUp : strDown)
    );
    parent.appendChild(tag);
  }
}

/**
 * 流入量描画
 * @param {]} parent 親タグ要素
 * @param {*} spec ダム諸量観測所情報
 * @param {*} value ダム諸量観測値
 * @param {*} offsetY 余白の高さ
 */
function addDamSink(parent, spec, value, offsetY) {
  // 表示位置
  const x = viewWidth - 260;
  const y = viewHeight * (1 - damTopRatio) + offsetY - 90;
  const rotate = 232.0;

  let tag, text;
  // 流入矢印描画
  if (checkCcd(value.sink, value.sinkCcd) && value.sink > 0) {
    let pArrow = "50 0 0 40 25 40 25 100 75 100 75 40 100 40";
    tag = document.createElement("polygon");
    tag.setAttribute("points", pArrow);
    tag.setAttribute("class", "kwd-dam-arrow");
    tag.setAttribute(
      "transform",
      "translate(" + x + "," + y + ") rotate(" + rotate + ".5,50,50)"
    );
    parent.appendChild(tag);
  }
  // 全流入量描画
  text =
    strSink +
    strDiv +
    toStringValueCheckCcd(value.sink, value.sinkCcd, fixedFlow, strFlowUnit);
  tag = document.createElement("text");
  tag.setAttribute("x", viewWidth - 270);
  tag.setAttribute("y", y + 60);
  tag.setAttribute("text-anchor", "end");
  tag.setAttribute("class", "kwd-dam-bold");
  tag.appendChild(document.createTextNode(text));
  parent.appendChild(tag);
}

/**
 * 放流量描画
 * @param {]} parent 親タグ要素
 * @param {*} value ダム諸量観測値
 * @param {*} offsetY 余白の高さ
 */
function addDamDisch(parent, value, offsetY) {
  // 表示位置
  const x = viewWidth * (1 - damRatio) - damBottomWidth - 100;
  const y = viewHeight * (1 - damTopRatio / 2) - 50 + offsetY;
  const rotate = 202.0;

  let tag, text;
  // 放流矢印描画
  if (checkCcd(value.disch, value.dischCcd) && value.disch > 0) {
    let pArrow = "50 0 0 40 25 40 25 100 75 100 75 40 100 40";
    tag = document.createElement("polygon");
    tag.setAttribute("points", pArrow);
    tag.setAttribute("class", "kwd-dam-arrow");
    tag.setAttribute(
      "transform",
      "translate(" + x + "," + y + ") rotate(" + rotate + ".5,50,50)"
    );
    parent.appendChild(tag);
  }
  // 全放流量描画
  text =
    strDisch +
    strDiv +
    toStringValueCheckCcd(value.disch, value.dischCcd, fixedFlow, strFlowUnit);
  tag = document.createElement("text");
  tag.setAttribute("x", x + 100);
  tag.setAttribute("y", y - 40);
  tag.setAttribute("text-anchor", "end");
  tag.setAttribute("class", "kwd-dam-bold");
  tag.appendChild(document.createTextNode(text));
  parent.appendChild(tag);
}

/**
 * 上流観測所描画
 * @param {*} parent 親タグ要素
 * @param {*} spec 雨量観測所情報
 * @param {*} value 雨量観測値
 * @param {*} isHour 時間/10分表示（true=時間, false=10分）
 * @param {*} offsetY 余白の高さ
 */
function addRainInfo(parent, spec, value, isHour, offsetY) {
  // 表示位置
  const x = viewWidth - 700 - viewPadding;
  const y = viewPadding + offsetY;
  const w = 700;
  const h = 140;

  if (null != spec) {
    let tag, text;
    let cls = "kwd-info-frame";
    let clsTxt = "kwd-dam-text";
    // 枠
    tag = document.createElement("rect");
    tag.setAttribute("x", x);
    tag.setAttribute("y", y);
    tag.setAttribute("width", w);
    tag.setAttribute("height", h);
    tag.setAttribute("rx", frameRadius);
    tag.setAttribute("ry", frameRadius);
    tag.setAttribute("class", cls);
    parent.appendChild(tag);
    // 観測所名
    tag = document.createElement("text");
    tag.setAttribute("x", x + w / 2);
    tag.setAttribute("y", y + 39);
    tag.setAttribute("text-anchor", "middle");
    tag.setAttribute("class", clsTxt);
    tag.appendChild(document.createTextNode(spec.name));
    parent.appendChild(tag);
    // 雨量
    text = (isHour ? strRainHour : strRainMin10) + strDiv;
    tag = document.createElement("text");
    tag.setAttribute("x", x + w * 0.65);
    tag.setAttribute("y", y + 83);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", clsTxt);
    tag.appendChild(document.createTextNode(text));
    parent.appendChild(tag);
    text = toStringValueCheckCcd(
      value.rain,
      value.rainCcd,
      fixedRain,
      strRainUnit
    );
    tag = document.createElement("text");
    tag.setAttribute("x", x + w - 24);
    tag.setAttribute("y", y + 83);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", clsTxt);
    tag.appendChild(document.createTextNode(text));
    parent.appendChild(tag);
    // 累加雨量
    text = strRainTotal + strDiv;
    tag = document.createElement("text");
    tag.setAttribute("x", x + w * 0.65);
    tag.setAttribute("y", y + 127);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", clsTxt);
    tag.appendChild(document.createTextNode(text));
    parent.appendChild(tag);
    text = toStringValueCheckCcd(
      value.total,
      value.totalCcd,
      fixedRain,
      strRainUnit
    );
    tag = document.createElement("text");
    tag.setAttribute("x", x + w - 24);
    tag.setAttribute("y", y + 127);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", clsTxt);
    tag.appendChild(document.createTextNode(text));
    parent.appendChild(tag);
  }
}

/**
 * ダム放流通知表示
 * @param {*} parent 親タグ要素
 * @param {*} dsch ダム放流通知
 * @param {*} offsetY 余白の高さ
 */
function addDamDsch(parent, dsch, offsetY) {
  // 表示位置
  const x = viewPadding;
  const y = viewPadding + offsetY;
  let w = 720;
  const h = 72;

  let cls = "none";
  let txt = strDamDschNone;

  let tag;
  if (
    null != dsch &&
    null != dsch.name &&
    (dsch.lvl === 50 || dsch.lvl === 70)
  ) {
    if (dsch.lvl === 50) {
      cls = "storop";
      txt = dsch.name;
    }
    if (dsch.lvl === 70) {
      cls = "prevop";
      txt = dsch.name;
    }

    if (dsch.name.length > 18) {
      // 枠サイズ変更
      w = 1000;
    }
    // 枠
    tag = document.createElement("rect");
    tag.setAttribute("x", x);
    tag.setAttribute("y", y);
    tag.setAttribute("width", w);
    tag.setAttribute("height", h);
    tag.setAttribute("rx", frameRadius);
    tag.setAttribute("ry", frameRadius);
    tag.setAttribute("class", "kwd-dam-dsch-rw-" + cls + "-frame");
    parent.appendChild(tag);
    // 発表内容
    tag = document.createElement("text");
    tag.setAttribute("x", x + w / 2);
    tag.setAttribute("y", y + 48);
    tag.setAttribute("text-anchor", "middle");
    tag.setAttribute("class", "kwd-dam-dsch-rw-" + cls + "-text");
    tag.appendChild(document.createTextNode(txt));
    parent.appendChild(tag);
  }
}

/**
 * ツールチップ表示文字列
 * @param {*} spec ダム諸量観測所情報
 * @return ツールチップ文字列
 */
function makeToolTip(spec) {
  const strCRLF = "\r\n";
  let str = "";
  let isSrchg = checkPeriod(spec.limitStage);
  let isSpare = checkPeriod(spec.spareStage);
  let start, end;

  if (isSrchg && null != spec.srchgStage && spec.srchgStage > spec.minStage) {
    str =
      strDamSrchg + strDiv + fixedNumber(spec.srchgStage, fixedStage) + strUnit;
  } else {
    if (null != spec.srchgStage && spec.srchgStage > spec.minStage) {
      str =
        strDamSrchg +
        strDiv +
        fixedNumber(spec.srchgStage, fixedStage) +
        strUnit +
        strCRLF +
        strDamNormal +
        strDiv +
        fixedNumber(spec.normalStage, fixedStage) +
        strUnit;
    } else {
      str =
        strDamNormal +
        strDiv +
        fixedNumber(spec.normalStage, fixedStage) +
        strUnit;
    }
  }

  if (isSrchg) {
    if (spec.proviso != null && spec.proviso != "") {
      str = str + strCRLF + strStagePrvs;
      str = str + strDiv + fixedNumber(spec.proviso, fixedStage) + strUnit;
    }

    start = spec.limitStage.start;
    end = spec.limitStage.end;
    str = str + strCRLF + strStageStandby + "(" + start + strPeriod + end + ")";
    str =
      str + strDiv + fixedNumber(spec.limitStage.value, fixedStage) + strUnit;
  }

  if (isSpare) {
    start = spec.spareStage.start;
    end = spec.spareStage.end;
    str = str + strCRLF + strStageReserve + "(" + start + strPeriod + end + ")";
    str =
      str + strDiv + fixedNumber(spec.spareStage.value, fixedStage) + strUnit;
  }

  return str;
}

/********** **********/

/**
 * 基準となる上限水位を算出
 * 設計最高水位＞洪水時最高水位＞平常時最高貯水位の優先度で設定されている値を使用
 * @param {*} normalStage 平常時最高貯水位
 * @param {*} srchgStage 洪水時最高貯水位
 * @param {*} dsgnFldLv 設計最高水位
 * @return 水位
 */
function getBaseStage(normalStage, srchgStage, dsgnFldLv) {
  if (null != dsgnFldLv) {
    return dsgnFldLv;
  } else if (null != srchgStage) {
    return srchgStage;
  }
  return normalStage;
}

/**
 * ダム水位描画位置算出
 * @param {*} base 基準となる上限水位
 * @param {*} min ダム最低水位
 * @param {*} lvl 描画対象水位
 * @param {*} maxPos 描画限界位置
 * @return 描画位置
 */
function computeDamStage(base, min, lvl, maxPos) {
  if (null != min && null != lvl && lvl > min) {
    let h = base - min;
    let s = lvl - min;
    let pos = Number(fixedNumber(s / h, fixedStage));
    // 描画限界位置を超えている場合は、限界位置を設定
    if (maxPos && pos > maxPos) {
      pos = maxPos;
    }
    return pos;
  }
  return null;
}

/********** **********/

/**
 * 適用期間判定
 * @param {*} item 制限水位情報 または 予備放流情報
 * @return true=期間内, false=期間外
 */
function checkPeriod(item) {
  if (
    item != null &&
    item.start != null &&
    item.end != null &&
    item.value != null
  ) {
    return true;
  }
  return false;
}

/**
 * 内容コード判定
 * @param {*} value 観測値
 * @param {*} ccd 内容コード
 * @return true=有効, false=無効
 */
function checkCcd(value, ccd) {
  if (null != value && ccd < 130) {
    return true;
  }
  return false;
}

/**
 * 内容コードに応じた文字列取得
 * @param {*} value 観測値
 * @param {*} ccd 内容コード
 * @param {*} digit 有効桁数
 * @param {*} unit 単位文字列
 * @return 表示文字列
 */
function toStringValueCheckCcd(value, ccd, digit, unit) {
  if (checkCcd(value, ccd)) {
    return fixedNumber(value, digit) + unit;
  } else if (ccd === 140) {
    return strClose;
  } else if (ccd === 190) {
    return strLess;
  }
  return strOther;
}

/**
 * 数値フォーマット桁区切り
 *
 * @param {?number} str 数値の文字列(数値の場合も処理可能)
 * @param {boolean} isException 桁区切りの例外(trueの場合は例外で桁区切りを行わない)
 * @returns {string} 桁区切り後の文字列(数値の文字列でない場合・例外の場合はstrのまま返す)
 */

function addComma(str, isException) {
  if (isException) {
    return str;
  } else if (typeof str === "number") {
    return str.toLocaleString();
  } else if (!isNaN(parseFloat(str))) {
    let splitNumStr = str.split(".");
    if (splitNumStr[1]) {
      return parseInt(splitNumStr[0]).toLocaleString() + "." + splitNumStr[1];
    } else {
      return parseInt(splitNumStr[0]).toLocaleString();
    }
  } else {
    return str;
  }
}

/********** **********/

// polygon用座標データ変換
function xy(x, y) {
  return x + " " + y + " ";
}

// 表示桁数
function fixedNumber(num, digit) {
  return addComma(Number(num).toFixed(digit));
}

/********** **********/

/**
 * SVGダム模式図取得
 * @param obsInfo 観測所情報
 *    value: 観測値
 *        date: 観測日
 *        time: 観測時間
 *        dam: ダム諸量(10分/時間雨量で切替)
 *            lvl: 貯水位
 *            lvlCcd: 貯水位内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            chg: 水位変化(up=増加, down=減少, non=変化なし)
 *            irr: 貯水率(利水容量)
 *            irrCcd: 貯水率(利水容量)内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            flood: 貯水率(治水容量)
 *            floodCcd: 貯水率(治水容量)コード(0=正常, 140=閉局, 190=欠測, その他)
 *            sink: 全流入量
 *            sinkCcd: 全流入量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            disch: 全放流量
 *            dischCcd: 全放流量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *        rain: 雨量
 *            rain: 10分/時間雨量
 *            rainCcd: 雨量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            cautOvflg: 10分/時間雨量 注意値超過フラグ
 *            warnOvflg: 10分/時間雨量 警戒値超過フラグ
 *            total: 累加雨量
 *            totalCcd: 累加雨量内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            totalCautOvflg: 累加雨量 注意値超過フラグ
 *            totalWarnOvflg: 累加雨量 警戒値超過フラグ
 *        stage: 下流水位(10分/時間雨量で切替)
 *            lvl: 水位(堤防天端から)
 *            lvlCcd: 水位内容コード(0=正常, 140=閉局, 190=欠測, その他)
 *            stgOvlvl: 基準水位超過
 *    dsch: ダム放流通知
 *        lvl: レベル(0=平常, 1=洪水貯留操作実地中, 2=異常洪水時防災操作等実施中)
 *        name: ダム放流通知種別名
 *    spec: 観測所情報
 *        dam: ダム諸量観測所
 *            name: 観測所名称
 *            proviso: 異常洪水時防災操作開始水位
 *            srchgStage: 洪水時最高水位
 *            normalStage: 平常時最高水位
 *            minStage: 最低水位
 *            floodctl: 洪水貯留操作開始流量
 *            dsgnFldLv: 設計最高水位
 *            limitStage: 洪水貯留準備水位
 *                value: 制限水位
 *                start: 制限水位期間開始
 *                end: 制限水位期間終了
 *            spareStage: 予備放流水位
 *                value: 制限水位
 *                start: 制限水位期間開始
 *                end: 制限水位期間終了
 *        rain: 関連雨量観測所
 *            name: 観測所名称
 *        stage: 下流水位観測雨所
 *            name: 観測所名称
 *            distance: ダムからの距離(km)
 *            label: 水位表記文字列
 *        obs: ダム諸量観測所
 *            obsNm: 観測所名称
 *            rsysNm: 水系名
 *            rvrNm: 河川名
 *            obsDt: 観測日時
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    isInfo: 観測所情報表示（true=表示, false=非表示）
 *    isFldCtl: 水防団モード（true=水防団, false=一般）
 * @param callback 画像生成後に呼び出すコールバック関数
 * @return SVGグラフ
 */
function getImageDamDiag(obsInfo, viewProp, callback) {
  const valueDam = obsInfo.value.dam;
  const valueRain = obsInfo.value.rain;
  const specDam = obsInfo.spec.dam;
  const specRain = obsInfo.spec.rain;
  const specObs = obsInfo.spec.obs;

  let offsetY = 0;

  // 画像サイズを縦横比１：２とする
  if (viewProp.isInfo && specObs != null) {
    // 観測所情報表示の場合は、情報表示領域を考慮
    let imgHeight =
      (viewHeight * viewProp.height) / (viewHeight + obsInfoHeight);
    if (viewProp.width / 2 >= imgHeight) {
      viewProp.width = imgHeight * 2;
    } else {
      viewProp.height =
        ((viewHeight + obsInfoHeight) * viewProp.width) / viewWidth;
    }
  } else {
    if (viewProp.width / 2 >= viewProp.height) {
      viewProp.width = viewProp.height * 2;
    } else {
      viewProp.height = viewProp.width / 2;
    }
  }

  // SVGタグ生成
  let svg = makeSvg(viewProp, specObs);

  // 観測所情報追加
  if (viewProp.isInfo && specObs != null) {
    offsetY = addObsInfo(
      svg,
      specObs.obsNm,
      specObs.rsysNm,
      specObs.rvrNm,
      specObs.obsDt
    );
  }

  let g = svg.childNodes[1];
  // ダム描画
  addDam(g, specDam, valueDam, offsetY);
  // 流入量描画
  addDamSink(g, specDam, valueDam, offsetY);
  // 放流量描画
  addDamDisch(g, valueDam, offsetY);
  // 上位観測所描画
  addRainInfo(g, specRain, valueRain, viewProp.isHour, offsetY);
  // ダム放流通知表示
  addDamDsch(g, obsInfo.dsch, offsetY);

  // 画像要素返却
  if (callback != null) {
    callback(svg);
  }

  return svg.outerHTML;
}

/**
 * 観測所情報追加
 * @param {*} parent 親要素
 * @param {*} obsNm 観測所名
 * @param {*} rsysNm 水系名
 * @param {*} rvrNm 河川名
 * @param {*} obsDt 観測日時
 * @return 観測所情報の高さ(px)
 */
function addObsInfo(parent, obsNm, rsysNm, rvrNm, obsDt) {
  let g, tag;
  const cls = "kwd-dam-obsinfo-label";
  const txt = obsNm + "  " + rsysNm + " " + rvrNm;

  // gタグ生成
  g = document.createElement("g");
  g.setAttribute("id", "svg-obsinfo");
  g.setAttribute("class", "svg-obsinfo");
  parent.appendChild(g);

  // 観測所情報タグ追加
  tag = document.createElement("text");
  tag.setAttribute("x", obsInfoPosX);
  tag.setAttribute("y", obsInfoHeight - 20);
  tag.setAttribute("class", cls);
  tag.appendChild(document.createTextNode(txt));
  g.appendChild(tag);
  tag = document.createElement("text");
  tag.setAttribute("x", viewWidth - obsInfoPosX);
  tag.setAttribute("y", obsInfoHeight - 20);
  tag.setAttribute("text-anchor", "end");
  tag.setAttribute("class", cls);
  tag.appendChild(document.createTextNode(obsDt));
  g.appendChild(tag);

  // 高さを返却
  return obsInfoHeight;
}
